import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import FieldHistoryDataAnalysisIndex from './analyses';
import FieldHistoryDataOwnershipIndex from './ownership';
import FieldHistoryDataMergeIndex from './merge';
import css from './index.module.css';

export default function FieldHistoryDataIndex() {
  const { t } = useTranslation();
  const tp = useCallback(
    (key: string) =>
      t('pages.crop.field-history.history.section.data.'.concat(key)),
    [t]
  );

  return (
    <>
      <h2 className={css['title']}>{tp('analysis.title')}</h2>
      <FieldHistoryDataAnalysisIndex />

      <h2 className={css['title']}>{tp('ownership.title')}</h2>
      <FieldHistoryDataOwnershipIndex />

      <h2 className={css['title']}>{tp('merge.title')}</h2>
      <FieldHistoryDataMergeIndex />
    </>
  );
}
